export default __webpack_public_path__ + "dcb0116e5b56f952f40fb294c8d85734.mp3";